import { app } from '@microsoft/teams-js';
import { endAndReportPerformanceMeasure, reportError, startPerformanceMeasure } from '@ms/yammer-telemetry';

type IsAppInitialized = () => boolean;
export const isAppInitialized: IsAppInitialized = () => app.isInitialized();

type EnsureInitializedWithTelemetry = () => Promise<void>;
export const ensureInitializedWithTelemetry: EnsureInitializedWithTelemetry = async () => {
  if (!isAppInitialized()) {
    const measure = startPerformanceMeasure('meta_os_hub_initialize');

    try {
      await app.initialize();
      endAndReportPerformanceMeasure(measure);
    } catch (error) {
      endAndReportPerformanceMeasure({
        ...measure,
        eventProperties: { ...measure.eventProperties, endedWithError: true },
      });

      const errorMessage = error instanceof Error ? error.message : String(error);

      reportError({
        error,
        eventProperties: {
          errorCode: 'MetaOsHubInitializationFailed',
          errorMessage,
        },
      });
    }
  }
};
